import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function DigitalWorkspace() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero Banner */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Digital Workspace Management</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Digital Workspace</div>
                                <h1 className="prod-hero-title">Digital Workspace <span>Management</span></h1>
                                <p>Virtualization and cloud computing have forever changed how employees connect, communicate and collaborate. A digital workspace is the foundation for business agility, high productivity, and better employee experience.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Digital Workspace" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Stats */}
            <section style={{ background: '#0a0a0a', padding: '0 0 20px' }}>
                <div className="container">
                    <div className="prod-stats-row">
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">28%</div>
                            <div className="prod-stat-label">Hybrid Work Adoption</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">32M+</div>
                            <div className="prod-stat-label">Remote Workers by 2025</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">40%</div>
                            <div className="prod-stat-label">Productivity Increase</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">100%</div>
                            <div className="prod-stat-label">Secure Anywhere Access</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* What is Digital Workspace */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/digital-2.webp')} alt="Digital Workspace" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Overview</div>
                                <h2>What Is a Digital Workspace?</h2>
                                <p>A digital workspace (also called a virtual workspace) is a set of evolving technologies that centralize the management and delivery of applications and desktops — allowing employees to access corporate resources securely from any location, on any device.</p>
                                <p>It simplifies and centralizes management of applications and devices via:</p>
                                <ul className="prod-benefits-list mt-2">
                                    <li><span className="ben-dot">✓</span>Application and desktop virtualization</li>
                                    <li><span className="ben-dot">✓</span>Mobile application management (MAM) &amp; device management (MDM)</li>
                                    <li><span className="ben-dot">✓</span>Enterprise mobility management (EMM)</li>
                                    <li><span className="ben-dot">✓</span>Secure SaaS access &amp; Identity management (SSO)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Use Cases */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Use Cases</div>
                        <h2 className="prod-section-title">Digital Workspace <span>Use Cases</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>A digital workspace flips the traditional workplace model, enabling organizations to derive maximum benefits</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-home"></i></div>
                            <h4>Mobile &amp; Remote Employees</h4>
                            <p>Access corporate resources including legacy applications from any location — whether working from home, co-working spaces, or while traveling across the globe.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-lightbulb-o"></i></div>
                            <h4>Knowledge Workers</h4>
                            <p>Designers, architects, and researchers can access sensitive projects securely from any endpoint. The digital workspace encrypts sensitive information accessible only to the team.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-file-text"></i></div>
                            <h4>Contractors</h4>
                            <p>IT administrators control access to applications and desktops for contract employees. Temporary workers perform tasks via corporate resources without accessing unrelated applications.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-hospital-o"></i></div>
                            <h4>Healthcare Workers</h4>
                            <p>Roaming doctors and clinicians leverage digital workspaces for immediate, secure access to sensitive patient data — from any location, with full compliance.</p>
                            <div className="prod-feature-number">04</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Benefits</div>
                        <h2 className="prod-section-title">Why Choose a <span>Digital Workspace?</span></h2>
                    </div>
                    <div className="prod-numbered-list">
                        <div className="prod-step-item">
                            <span className="prod-step-num">01</span>
                            <div>
                                <h4>Enhanced Flexibility</h4>
                                <p>Digital workspace platforms allow employees to work at any time, from anywhere, via their preferred devices — increasing flexibility in both work environments and schedules.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">02</span>
                            <div>
                                <h4>Foster Productivity</h4>
                                <p>Research shows that more engaged workers are self-driven, innovative, and productive. Digital workspaces eliminate time-wasting application search across multiple endpoints and sign-ins.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">03</span>
                            <div>
                                <h4>Enhanced Collaboration</h4>
                                <p>Facilitates easy interactions between supervisors and coworkers. By sharing documents and data in real-time, employees can work on projects regardless of geographical locations.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">04</span>
                            <div>
                                <h4>Reduce Operating Costs</h4>
                                <p>Eliminates the need for a traditional workplace environment by allowing BYOD with appropriate policies — saving costs in telecommunications, hardware, support, and training.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">05</span>
                            <div>
                                <h4>Higher Employee Retention</h4>
                                <p>Flexible working styles make employees feel appreciated — increasing satisfaction levels and making them more likely to remain committed to the organization for extended periods.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Visual Feature Split */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/technology/ai-1.webp')} alt="Remote Access" />
                            </div>
                            <p style={{ color: 'rgba(255,255,255,0.65)', marginTop: 16, fontSize: 15, lineHeight: 1.75 }}>
                                A digital workspace allows employees to access corporate resources including legacy applications — enforcing compliance requirements such as PCI DSS for regulated industries like banks.
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/technology/ai-2.webp')} alt="Secure Access" />
                            </div>
                            <p style={{ color: 'rgba(255,255,255,0.65)', marginTop: 16, fontSize: 15, lineHeight: 1.75 }}>
                                For traveling employees, a digital workspace allows secure work from any location — with only risk-appropriate applications and desktops accessible per situation.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Empower Your Digital Workforce?</h3>
                            <p>Let CLOUD MIND design and deploy a secure digital workspace tailored to your organization's needs.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
